import { BaseDto } from './base.dto';

export class StockUnitDto extends BaseDto {
  name: string;
  type: string;
  merchantId: number;
  multiplier: number;
  baseUnit?: string;
  isBaseUnit: boolean;
  nameConversion?: string;
}
